<script>
import Vue from 'vue'
import { MODAL, RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { apiCrmTranscricoes } from '@modules/crm/api/apiCrmTranscricoes'
import { apiCrmTranscricaoProjetos } from '@modules/crm/api/apiCrmTranscricaoProjetos'

const buildDefaultItem = () => ({
  id: null,
  id_project: null,
})

export default {
  name: 'TranscriptLinkProjectModal',
  data() {
    return {
      busModal: new Vue(),
      item: buildDefaultItem(),
      projectOptions: [],
      loadingProjects: false,
      loading: false,
    }
  },
  created() {
    GlobalBus.$on(MODAL.TRANSCRIPT_PROJECT, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.TRANSCRIPT_PROJECT, this.open)
  },
  methods: {
    clear() {
      this.item = buildDefaultItem()
      this.loading = false
    },
    open({ id = null, id_project = null } = {}) {
      this.clear()
      this.item = { id: id || null, id_project: id_project || null }
      this.loadProjetos()
      this.busModal.$emit('dialog', true)
    },
    // Carrega os projetos do escritório (inclui modelos globais do escritório 1).
    // A chamada, o cache e a normalização vivem na API (apiCrmTranscricaoProjetos.
    // carregar), que despacha pro store — fonte única: a aba de Projetos lê a MESMA
    // lista pelos getters. Aqui só chamamos a API e mapeamos pro shape {text,value}.
    async loadProjetos() {
      if (this.loadingProjects) return
      this.loadingProjects = true
      try {
        const r = await apiCrmTranscricaoProjetos.carregar()
        if (r && r.status !== 200) {
          this.$showSnack(r)
          return
        }
        const projects = this.$store.getters['crm/transcriptProjects'] || []
        this.projectOptions = projects
          .map((p) => ({ value: p.id, text: p.name || 'Projeto sem nome' }))
          .filter((o) => o.value)
          .sort((a, b) => String(a.text).localeCompare(String(b.text)))
      } finally {
        this.loadingProjects = false
      }
    },
    // Projeto é opcional: id_project null desvincula. Sem validação obrigatória.
    async save() {
      if (this.loading) return
      if (!this.item.id) return

      this.loading = true
      try {
        const r = await apiCrmTranscricoes.atualizar({
          id: this.item.id,
          id_project: this.item.id_project || null,
        })

        if (r && r.status === 200) {
          this.busModal.$emit('dialog', false)
          // Atualiza a lista de transcrições e o modal de detalhe aberto.
          GlobalBus.$emit(RELOAD.TRANSCRIPT)
        }

        this.$showSnack(r)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="500px"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Alterar projeto vinculado</span>
      </div>

      <div class="modal-content">
        <v-row>
          <v-col class="d-flex flex-column py-1" cols="12">
            <InputByType
              v-model="item.id_project"
              type="autocomplete"
              :options="projectOptions"
              :loading="loadingProjects"
              placeholder="Selecione um projeto"
              outlined
              clearable
              class="align-icon-search"
              labelExternal="Projeto"
            />
          </v-col>
        </v-row>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <div class="d-flex mt-4 az-gap-small">
        <BaseButton underlined @click="close"> Cancelar </BaseButton>
        <BaseButton primary :loading="loading" @click="save">
          Salvar
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
